<template>
  <vs-popup 
    :title="$t('UploadImage')" 
    :active.sync=" popupActive" 
    v-if="isActive"
  >
    <vs-card class="upload-popup-card p-6 space-y-6">
      <div class="text-center">
        <h3 class="text-lg font-semibold text-gray-900">{{ $t('UploadImage') }}</h3>
      </div>

      <div class="upload-area relative border-2 border-dashed border-gray-300 rounded-lg p-6 flex flex-col items-center justify-center w-full h-full">
        <span class="upload-text text-sm text-gray-500">
          {{ $t('DragDropImageOrClick') }}
        </span>
        <input 
          ref="fileInput"
          type="file"
          accept="image/*"
          @change="successUpload"
          class="absolute inset-0 opacity-0 cursor-pointer" 
        />
        <img 
          v-if="imageUpload"
          :src="imageUpload"
          :key="previewKey"
          class="mt-4 w-full max-h-48 object-contain rounded-md"
          :alt="$t('Preview')" 
        />
      </div>

      <div class="flex items-center">
        <div class="flex-grow border-t border-gray-300"></div>
        <span class="mx-4 text-sm text-gray-500">{{ $t('OR') }}</span>
        <div class="flex-grow border-t border-gray-300"></div>
      </div>

      <div class="space-y-4">
        <vs-input 
          v-model="imageUrl"
          :placeholder="$t('EnterImageURL')"
          class="url-input block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
        />
        <vs-button 
          color="#0077cc"
          type="filled"
          class="submit-url-button w-full px-4 py-2 bg-blue-600 text-white font-semibold rounded-md shadow hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          @click="onUrlSubmit"
        >
          {{ $t('Submit') }}
        </vs-button>
      </div>
    </vs-card>
  </vs-popup>
</template>

<script>
export default {
  name: 'ImageUploadPopup',
  
  props: {
    isActive: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      imageUrl: '',
      imageUpload: null,
      previewKey: 0
    }
  },

  methods: {
    async successUpload(evt) {
      const file = evt.srcElement.files[0];
      if (file) {
        let result_base64 = await new Promise((resolve) => {
          let fileReader = new FileReader();
          fileReader.onload = (e) => resolve(fileReader.result);
          fileReader.readAsDataURL(file);
        });

        this.imageUpload = result_base64;
        this.previewKey++;
        
        this.$emit('upload-image', result_base64, file.name);
      }
    },

    onUrlSubmit() {
      this.$emit('url-upload', this.imageUrl)
      this.imageUrl = ''
    }
  },

  //watch: {
  //  isActive(newVal) {
  //    if (!newVal) {
  //      this.imageUrl = ''
  //      this.imageUpload = null
  //      this.previewKey = 0
  //    }
  //  }
        //}

  computed: {
       popupActive: {
          get() {
               this.imageUrl = ''
               this.imageUpload = null
               this.previewKey = 0
               return this.isActive
          },
          set(value) {
              this.$emit('update:isActive', value)
          }
       }
  },
}
</script>

<style lang="scss" scoped>
.upload-area {
  min-height: 200px;
  transition: border-color 0.3s ease;

  &:hover {
    border-color: #0077cc;
  }
}
</style> 
